import { render, staticRenderFns } from "./MdDialog.vue?vue&type=template&id=6297879b"
import script from "./MdDialog.vue?vue&type=script&lang=js"
export * from "./MdDialog.vue?vue&type=script&lang=js"
import style0 from "./MdDialog.vue?vue&type=style&index=0&id=6297879b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports